import { render } from "./DefinitionOfConsequence.vue?vue&type=template&id=ab2a498a&scoped=true"
import script from "./DefinitionOfConsequence.vue?vue&type=script&lang=js"
export * from "./DefinitionOfConsequence.vue?vue&type=script&lang=js"

import "./DefinitionOfConsequence.vue?vue&type=style&index=0&id=ab2a498a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab2a498a"]])

export default __exports__